import React, { useEffect, useState } from "react";

// Loacal imports
import PageLoader from "../global/page-loader";
import CTAStrip from "../global/cta.strip";

// Live imports
import { NavLink as Link, withRouter } from "react-router-dom";

function TermsAndConditions() {
  return (
    <>
      <PageLoader />
      <div className="breadcrumb-wrapper">
        <div className="images-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="page-heading">
                <h1>Terms And Conditions</h1>
                <span className="line"></span>
              </div>
              <div className="page-breadcrumb-inner">
                <div className="page-breadcrumb">
                  <div className="breadcrumb-list">
                    <ul>
                      <li>
                        <Link to="/" activeclass="active">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/terms-and-conditions" activeclass="active">
                          Terms And Conditions
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CTAStrip />
    </>
  );
}

export default withRouter(TermsAndConditions);
